import React from 'react';

import { clsx } from 'clsx';

type SectionHeaderProps = React.PropsWithChildren & {
  className?: string;
};

const SectionHeader = (props: SectionHeaderProps) => {
  return <h1 className={clsx(props.className, 'mb-2 text-4xl')}>{props.children}</h1>;
};

export default SectionHeader;
